import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function CreateTenant() {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [loading, setLoading] = useState(false);
  const { createTenant } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await createTenant(name, slug);
      toast({
        title: "Tenant creado exitosamente",
        description: "Tu nuevo tenant ha sido creado y está listo para usar.",
      });
      navigate(`/${slug}/dashboard`);
    } catch (error) {
      toast({
        title: "Error al crear tenant",
        description:
          "Hubo un problema al crear tu tenant. Por favor, inténtalo de nuevo.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Crear nuevo tenant</CardTitle>
          <CardDescription>
            Configura un nuevo espacio de trabajo para tu organización
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Nombre del tenant</Label>
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Mi Organización"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="slug">URL del tenant</Label>
              <Input
                id="slug"
                value={slug}
                onChange={(e) =>
                  setSlug(e.target.value.toLowerCase().replace(/\s+/g, "-"))
                }
                placeholder="mi-organizacion"
                required
              />
              <p className="text-sm text-gray-500">
                Esta será la URL de tu tenant: miasistentelegalia.com/{slug}
              </p>
            </div>
          </CardContent>
          <CardFooter className="flex justify-between">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate(-1)}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Creando..." : "Crear tenant"}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
